import { useQuery } from '@tanstack/react-query';
import { fetchDeviceModelById } from '@/api/common';

export const deviceModelDetailKeys = {
  detail: (id: number) => ['deviceModels', id] as const,
};

export function useDeviceModelDetail(id: number) {
  return useQuery({
    queryKey: deviceModelDetailKeys.detail(id),
    queryFn: () => fetchDeviceModelById(id),
    enabled: id > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
}
